import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "SortContainer" }
const _hoisted_2 = { class: "SortDropdownListDesktop" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "check-icon lnr-check"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortingOptions, (option) => {
        return (_openBlock(), _createElementBlock("li", {
          onClick: ($event: any) => (_ctx.select(option.id))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass([option.iconClass, "MobileOnlyBlock SearchSortOptionIcon"])
          }, null, 2 /* CLASS */),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.isSelected(option.id) ? 'is-active' : '')
          }, _toDisplayString(option.label), 3 /* TEXT, CLASS */),
          (_ctx.isSelected(option.id))
            ? (_openBlock(), _createElementBlock("i", _hoisted_4))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_3))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}